import fastDeepEqual from "fast-deep-equal/react.js";
import { useContext, useEffect, useRef } from "react";
import { useFormContext } from "react-hook-form";
import contextBabylon from "../../../../../context/index.js";
import useValue from "../../../../../hooks/forms/useValue.js";
import useLastValue from "../../../../../hooks/useLastValue.js";
import usePrevValue from "../../../../../hooks/usePrevValue.js";
import { getAirportCodeByDestination, getApplicableDiscounts, getFlightOperative } from "../service.js";
const useUpdateAirportCode = (contextValue)=>{
    const { props , state , actions  } = contextValue;
    const { config  } = props ?? {};
    const { endpoints  } = config ?? {};
    const { destinationAirport , callLocks  } = state ?? {};
    const { destinationAirportCallErrorLock , destinationAirportCallLock  } = callLocks ?? {};
    const { doFetchLoading , setDestinationAirports  } = actions ?? {};
    const { setValue , getValues , trigger  } = useFormContext();
    const { BaseUrl  } = useContext(contextBabylon);
    const destinationValue = useValue({
        name: 'destination'
    });
    const prevDestination = usePrevValue(destinationValue);
    const lastPrevDestination = useLastValue(prevDestination);
    useEffect(()=>{
        if (!destinationAirportCallErrorLock) return;
        if (lastPrevDestination.current?.value !== destinationValue?.value) {
            destinationAirportCallErrorLock.current = false;
        }
        const updateAirportCode = async ()=>{
            if (!destinationAirportCallLock || !setDestinationAirports || !doFetchLoading || !destinationValue?.id || !destinationValue.value || !destinationValue.type || !!destinationAirport || destinationAirportCallErrorLock.current) return;
            const airportCode = await doFetchLoading(destinationAirportCallLock, async ()=>await getAirportCodeByDestination(endpoints?.airportByDestination, {
                    destination: destinationValue
                }, {
                    BaseUrl
                }), ()=>destinationAirportCallErrorLock.current = true);
            if (airportCode) {
                setDestinationAirports((oldDestinationAirport)=>({
                        ...oldDestinationAirport,
                        [destinationValue?.id]: airportCode
                    }));
                setTimeout(()=>{
                    trigger([
                        'destination'
                    ]).catch(console.error);
                });
            }
        };
        updateAirportCode().catch(console.error);
    }, [
        BaseUrl,
        destinationAirport,
        doFetchLoading,
        endpoints?.airportByDestination,
        getValues,
        lastPrevDestination,
        setValue,
        trigger,
        destinationValue,
        destinationAirportCallErrorLock,
        destinationAirportCallLock,
        setDestinationAirports
    ]);
};
const useUpdateDiscounts = (contextValue)=>{
    const { props , state , actions  } = contextValue;
    const { config  } = props ?? {};
    const { endpoints  } = config ?? {};
    const { discounts , callLocks  } = state ?? {};
    const { discountsCallErrorLock , discountsCallLock  } = callLocks ?? {};
    const { doFetchLoading , setDiscounts  } = actions ?? {};
    const { setValue  } = useFormContext();
    const { BaseUrl , Language , Application  } = useContext(contextBabylon);
    const originValue = useValue({
        name: 'origin'
    });
    const destinationValue = useValue({
        name: 'destination'
    });
    const lastDiscounts = useLastValue(discounts);
    const prevDestination = usePrevValue(destinationValue);
    const lastPrevDestination = useLastValue(prevDestination);
    const prevOrigin = usePrevValue(originValue);
    const lastPrevOrigin = useLastValue(prevOrigin);
    const discountsLock = useRef(false);
    useEffect(()=>{
        if (!discountsCallErrorLock) return;
        if (lastPrevDestination.current?.value !== destinationValue?.value || lastPrevOrigin.current?.value !== originValue?.value) {
            discountsCallErrorLock.current = false;
            discountsLock.current = false;
        }
        const updateDiscounts = async ()=>{
            if (!discountsCallLock || !setDiscounts || !doFetchLoading || !originValue?.value || !destinationValue?.value || !destinationValue?.type || discountsCallErrorLock.current || discountsLock.current) {
                return;
            }
            const newDiscounts = await doFetchLoading(discountsCallLock, async ()=>await getApplicableDiscounts(endpoints?.discounts, {
                    origin: originValue,
                    destination: destinationValue
                }, {
                    BaseUrl,
                    Language,
                    Application
                }), ()=>discountsCallErrorLock.current = true);
            discountsLock.current = true;
            if (newDiscounts && !fastDeepEqual(lastDiscounts.current, newDiscounts)) {
                setDiscounts(newDiscounts);
            }
        };
        updateDiscounts().catch(console.error);
    }, [
        Application,
        BaseUrl,
        Language,
        doFetchLoading,
        endpoints?.discounts,
        lastDiscounts,
        lastPrevDestination,
        lastPrevOrigin,
        setValue,
        destinationValue,
        originValue,
        discountsCallErrorLock,
        discountsCallLock,
        setDiscounts
    ]);
};
const useUpdateFlightOperative = (contextValue)=>{
    const { props , state , actions  } = contextValue;
    const { config  } = props ?? {};
    const { endpoints  } = config ?? {};
    const { flightOperative , callLocks , originDestinationKey  } = state ?? {};
    const { flightOperativeCallErrorLock , flightOperativeCallLock  } = callLocks ?? {};
    const { doFetchLoading , setFlightOperatives  } = actions ?? {};
    const { BaseUrl , Application  } = useContext(contextBabylon);
    const originValue = useValue({
        name: 'origin'
    });
    const destinationValue = useValue({
        name: 'destination'
    });
    const lastFlightOperative = useLastValue(flightOperative);
    const prevDestination = usePrevValue(destinationValue);
    const lastPrevDestination = useLastValue(prevDestination);
    const prevOrigin = usePrevValue(originValue);
    const lastPrevOrigin = useLastValue(prevOrigin);
    useEffect(()=>{
        if (!flightOperativeCallErrorLock) return;
        if (lastPrevDestination.current?.value !== destinationValue?.value || lastPrevOrigin.current?.value !== originValue?.value) {
            flightOperativeCallErrorLock.current = false;
        }
        const updateFlightOperative = async ()=>{
            if (!flightOperativeCallLock || !originDestinationKey || !setFlightOperatives || !doFetchLoading || !originValue?.value || !destinationValue?.value || !destinationValue?.type || !!lastFlightOperative.current || flightOperativeCallErrorLock.current) return;
            const newFlightOperative = await doFetchLoading(flightOperativeCallLock, async ()=>await getFlightOperative(endpoints?.operative, {
                    origin: originValue,
                    destination: destinationValue
                }, {
                    BaseUrl,
                    Application
                }), ()=>flightOperativeCallErrorLock.current = true);
            if (newFlightOperative) {
                setFlightOperatives((oldFlightOperative)=>({
                        ...oldFlightOperative,
                        [originDestinationKey]: newFlightOperative
                    }));
            }
        };
        updateFlightOperative().catch(console.error);
    }, [
        Application,
        BaseUrl,
        doFetchLoading,
        endpoints?.operative,
        lastFlightOperative,
        lastPrevDestination,
        lastPrevOrigin,
        originDestinationKey,
        destinationValue,
        originValue,
        flightOperativeCallErrorLock,
        flightOperativeCallLock,
        setFlightOperatives
    ]);
};
const useDestinationValidationTrigger = ()=>{
    const { setValue , trigger  } = useFormContext();
    const originValue = useValue({
        name: 'origin'
    });
    const destinationValue = useValue({
        name: 'destination'
    });
    const prevDestination = usePrevValue(destinationValue);
    const lastPrevDestination = useLastValue(prevDestination);
    const prevOrigin = usePrevValue(originValue);
    const lastPrevOrigin = useLastValue(prevOrigin);
    useEffect(()=>{
        if (String(lastPrevDestination.current?.value) !== String(destinationValue?.value) || String(lastPrevOrigin.current?.value) !== String(originValue?.value)) {
            setTimeout(()=>{
                if (String(lastPrevOrigin.current?.value) !== String(originValue?.value)) setValue('destination', destinationValue, {
                    shouldValidate: true,
                    shouldDirty: true,
                    shouldTouch: true
                });
                trigger([
                    'destination'
                ]).catch(console.error);
            });
        }
    }, [
        lastPrevDestination,
        lastPrevOrigin,
        setValue,
        trigger,
        destinationValue,
        destinationValue?.value,
        originValue?.value
    ]);
};
const useDestinationRegister = (contextValue)=>{
    const { props  } = contextValue;
    const { destination , config  } = props ?? {};
    const { hideDestination =false  } = config ?? {};
    const { setValue  } = useFormContext();
    useEffect(()=>{
        if (hideDestination && destination) {
            setValue('destination', destination);
        }
    }, [
        hideDestination,
        destination,
        setValue
    ]);
};
const useSearcherFlightHotelSideEffects = (contextValue)=>{
    useDestinationValidationTrigger();
    useDestinationRegister(contextValue);
    useUpdateAirportCode(contextValue);
    useUpdateDiscounts(contextValue);
    useUpdateFlightOperative(contextValue);
};
export default useSearcherFlightHotelSideEffects;

//# sourceMappingURL=useSideEffects.js.map